import _typeof from "/app/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { listUserGroups, listTerms, listTermsCustomer, listCurrencies, WineRangeAccessibilityEnum, listWineRangeAccessibility, orderStatus, pricePostingUsaProConstants, userSubscriptionStatus, COUNTRIES } from "@/js/lists.ts";
import { cleanErrors, noErrors, getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import { getFullNameUser, COUNTRY_SPECIAL_WORDINGS } from "@/js/user/user.js";
import { regExpPhone, regExpMail, regexpConsulantCode } from "@/js/regexp_validation.js";
import { getUserLogged, hasRole, isAdminNotConsultant, isHolding, isConsultantOrHolding, isBuyerGroup, isSalesman, isSuperAdmin, getLimitedLocations, getClientAppData } from "@/js/http/auth.js";
import * as orderHandler from "@/js/order/order.js";
import { setCurrencyUsedForCartAndExplore } from "@/js/currency/currencies.js";
import addressComponent from "@/components/address/Address.vue";
import returnComponent from "@/components/navigation/ReturnToList.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import SendMailModal from "@/components/mail/SendMailModal.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "adminUserDetails",
  components: {
    addressComponent: addressComponent,
    return: returnComponent,
    confirm: confirmationComponent,
    SendMailModal: SendMailModal,
    ErrorModal: ErrorModal
  },
  props: ["loggedUserData"],
  data: function data() {
    return {
      clientAppData: null,
      isAuthorized: false,
      isLoaded: false,
      familyFriendsCommission: null,
      user: {
        id_user: null,
        login: "",
        password: "",
        passwordconfirm: "",
        name: "",
        nickname: "",
        phone: "",
        default_currency: "",
        factoring_provider: {
          id: null
        },
        company_name: "",
        billingEmail: "",
        contactEmail: "",
        accountingExternalId: null,
        id_language: 2,
        user_group: "",
        user_sub_group: "ADMIN",
        isHolding: false,
        isAllowedToDispatchToAnyone: false,
        id_term: 1,
        email: "",
        vat_code: "",
        excise_code: "",
        consultant_code: "",
        sponsorship_code: "",
        //Temp before complete launch of feature CategoryUser
        rangeAccessibility: WineRangeAccessibilityEnum.FINE_AND_RARE,
        contact: "",
        active: true,
        archive: false,
        deleted: false,
        has_bypass_buy_limit: false,
        is_allowed_order_without_payment: false,
        billing_is_delivery: false,
        delivery_address: {
          street: "",
          address_line_2: null,
          address_line_3: null,
          address_complement: null,
          zip: "",
          city: "",
          state: "",
          country: ""
        },
        billing_address: {
          street: "",
          address_line_2: null,
          address_line_3: null,
          address_complement: null,
          zip: "",
          city: "",
          state: "",
          country: ""
        },
        salesman_follower: {
          id_user: 0
        }
      },
      handlingUserActivationStatus: {
        activating: {
          isPending: false,
          cancellationToken: null
        },
        deactivating: {
          isPending: false,
          cancellationToken: null
        }
      },
      handlingUserSubscriptionStatus: {
        accepting: {
          isPending: false,
          cancellationToken: null
        },
        declining: {
          isPending: false,
          cancellationToken: null
        },
        resetting: {
          isPending: false,
          cancellationToken: null
        }
      },
      gettingConsultants: {
        isPending: false,
        cancellationToken: null,
        items: []
      },
      selectedConsultant: null,
      hide_billing_address: null,
      isFromList: null,
      listCountries: [],
      listStates: [],
      isUserConsultant: false,
      isUserAssociatedToConsultant: false,
      isSalesman: false,
      initialDeliveryCountryId: null,
      initialCurrency: null,
      listSalesman: [],
      listFactoringProviders: [],
      sendMailModalShown: false,
      welcomeMailCancellationToken: null,
      addingLimitedLocation: {
        isConfiguring: false,
        form: {
          countryId: null,
          stateId: null
        },
        availableStates: []
      },
      errorLabels: {
        login: "",
        email: "",
        name: "",
        nickname: "",
        phone: "",
        company_name: "",
        billingEmail: "",
        contactEmail: "",
        id_language: "",
        id_term: "",
        user_group: "",
        contact: "",
        vat_code: "",
        consultant_code: ""
      },
      errorMessages: {
        mandatory: "This field is required",
        email: {
          format: "Incorrect format, valid email address expected"
        },
        consultant_code: {
          format: "Incorrect format, 6 chars minimum"
        },
        password: {
          tooeasy: "Your password should be at least 8 characters, 1 digit, 1 uppercase letter, 1 lowercase letter and 1 special character (@$!%*?&)",
          unknown: "Incorrect login or password"
        },
        passwordconfirm: {
          nomatch: "Passwords do not match"
        },
        phone: {
          format: "Incorrect format, valid phone number expected"
        }
      },
      managedExceptions: {
        warning: {
          sponsorshipcode_unknown: "The keypass is not valid. Please verify it",
          sponsorshipcode_not_compatible_individual: "The keypass is not valid for individual customers",
          sponsorshipcode_not_compatible_country: "This keypass is not valid for this delivery country",
          consultantcode_keypass: "The consultant code is a manual keypass",
          consultantcode_exists: "The consultant code already exists",
          login_exists: "This email address is already used",
          create_user_exists: "This email address is already used on an activated account.",
          create_user_exists_deactivated: "This email address is already used. The account is deactivated for the moment",
          create_user_exists_archived: "This email address is already used. The account is archived, and probably deactivated too"
        }
      },
      listTerms: listTerms,
      listTermsCustomer: listTermsCustomer,
      userSubscriptionStatus: userSubscriptionStatus,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isAdding: function isAdding() {
      return !this.user.id_user;
    },
    canEditExistingUserGroup: function canEditExistingUserGroup() {
      return this.isAdminNotConsultant(this.loggedUserData) && this.canManage && !!this.user.id_user && isBuyerGroup(this.user.user_group);
    },
    listUserGroupsAvailable: function listUserGroupsAvailable() {
      if (this.canEditExistingUserGroup) {
        var _this$user$factoring_;
        var forceIncluded = [];
        if (!this.canManageFactoringProviders && (_this$user$factoring_ = this.user.factoring_provider) !== null && _this$user$factoring_ !== void 0 && _this$user$factoring_.id) {
          if (this.user.factoring_provider.isIndividual) {
            forceIncluded.push("USER");
          }
          if (this.user.factoring_provider.isProfessional) {
            forceIncluded.push("HORECA");
          }
          if (this.user.factoring_provider.isWholesaler) {
            forceIncluded.push("WHOLESALER");
          }
        }
        return listUserGroups.filter(function (x) {
          return (x.id === "USER" || x.id === "HORECA" || x.id === "WHOLESALER") && (forceIncluded.length == 0 || forceIncluded.includes(x.id));
        });
      } else {
        var groups = _toConsumableArray(listUserGroups).filter(function (x) {
          return x.id !== "WINEMAKER";
        });
        if (isHolding(this.loggedUserData)) {
          groups = groups.filter(function (x) {
            return x.id === "HORECA";
          });
        } else if (isConsultantOrHolding(this.loggedUserData)) {
          groups = groups.filter(function (x) {
            return x.id !== "ADMIN";
          });
        } else {
          groups.find(function (x) {
            return x.id === "ADMIN";
          }).name = "Admin / Consultant / Corporate";
        }
        return groups;
      }
    },
    isUserAdmin: function isUserAdmin() {
      return this.user.user_group == "ADMIN";
    },
    isUserAdminNotConsultant: function isUserAdminNotConsultant() {
      return this.isUserAdmin && !this.isUserConsultant;
    },
    isUserConsultantOrHolding: function isUserConsultantOrHolding() {
      return this.isUserConsultant || this.user.user_group == "ADMIN" && (this.user.user_sub_group == "CONSULTANT" || this.user.user_sub_group == "CONSULTANT_HOLDING");
    },
    isUserCorporate: function isUserCorporate() {
      return this.user.user_group == "ADMIN" && this.user.user_sub_group == "CONSULTANT_HOLDING";
    },
    isUserHorecaOrWholesaler: function isUserHorecaOrWholesaler() {
      return this.user.user_group == "HORECA" || this.user.user_group == "WHOLESALER";
    },
    isUserIndividual: function isUserIndividual() {
      return this.user.user_group == "USER";
    },
    isUserHasSponsorshipCode: function isUserHasSponsorshipCode() {
      var _this$user$sponsorshi;
      return isBuyerGroup(this.user.user_group) && ((_this$user$sponsorshi = this.user.sponsorship_code) === null || _this$user$sponsorshi === void 0 ? void 0 : _this$user$sponsorshi.length) > 0;
    },
    isFamilyFriendsAvailable: function isFamilyFriendsAvailable() {
      var _this2 = this;
      return !this.isUserAdminNotConsultant && !((this.user.user_group === "HORECA" || this.user.user_group === "WHOLESALER") && this.user.delivery_address.country.iso_code === "USA" && pricePostingUsaProConstants.some(function (state) {
        return state.iso2 === _this2.user.delivery_address.state.iso_state;
      })) && !this.isUserAssociatedToConsultant;
    },
    isChangingDeliveryCountry: function isChangingDeliveryCountry() {
      var _this$user$delivery_a;
      return this.initialDeliveryCountryId !== ((_this$user$delivery_a = this.user.delivery_address.country) === null || _this$user$delivery_a === void 0 ? void 0 : _this$user$delivery_a.id_country);
    },
    isUserSubscriptionStatusDeclined: function isUserSubscriptionStatusDeclined() {
      return this.user.subscriptionStatus === this.userSubscriptionStatus.DECLINED.id && !this.user.active;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.handlingUserActivationStatus.activating.isPending || this.handlingUserActivationStatus.deactivating.isPending || this.handlingUserSubscriptionStatus.accepting.isPending || this.handlingUserSubscriptionStatus.declining.isPending || this.handlingUserSubscriptionStatus.resetting.isPending;
    },
    canManage: function canManage() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_USER);
    },
    canManageMyUsers: function canManageMyUsers() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_MY_USERS);
    },
    canManageFactoringProviders: function canManageFactoringProviders() {
      return isAdminNotConsultant(this.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_FACTORING);
    },
    canManageLimitedLocations: function canManageLimitedLocations() {
      return this.isUserAdminNotConsultant && isSuperAdmin(this.loggedUserData);
    },
    isDeleted: function isDeleted() {
      return !!this.user.id_user && this.user.deleted;
    },
    readOnly: function readOnly() {
      return this.isConsultantOrHolding(this.loggedUserData) && !this.isAdding && (!this.user.active || this.user.is_archived) || this.isAdminNotConsultant(this.loggedUserData) && !this.canManage && !this.isAdding || this.isDeleted;
    },
    canChangeCurrency: function canChangeCurrency() {
      return this.listDefaultCurrencies.length > 1;
    },
    listDefaultCurrencies: function listDefaultCurrencies() {
      var _this$user,
        _this$user2,
        _this$user$factoring_2,
        _this3 = this;
      var availableCurrencies = [];
      if (((_this$user = this.user) === null || _this$user === void 0 || (_this$user = _this$user.delivery_address) === null || _this$user === void 0 || (_this$user = _this$user.country) === null || _this$user === void 0 ? void 0 : _this$user.id_country) === COUNTRIES.USA.id) {
        availableCurrencies = ["USD"];
      } else if (((_this$user2 = this.user) === null || _this$user2 === void 0 || (_this$user2 = _this$user2.delivery_address) === null || _this$user2 === void 0 || (_this$user2 = _this$user2.country) === null || _this$user2 === void 0 ? void 0 : _this$user2.id_country) === COUNTRIES.BAHAMAS.id) {
        availableCurrencies = ["BSD", "USD"];
      } else {
        var _this$user3;
        availableCurrencies.push("EUR");
        if ((_this$user3 = this.user) !== null && _this$user3 !== void 0 && (_this$user3 = _this$user3.delivery_address) !== null && _this$user3 !== void 0 && (_this$user3 = _this$user3.country) !== null && _this$user3 !== void 0 && _this$user3.currency) availableCurrencies.push(this.user.delivery_address.country.currency);
      }
      if (!this.canManageFactoringProviders && ((_this$user$factoring_2 = this.user.factoring_provider) === null || _this$user$factoring_2 === void 0 || (_this$user$factoring_2 = _this$user$factoring_2.currencies) === null || _this$user$factoring_2 === void 0 ? void 0 : _this$user$factoring_2.length) > 0) {
        availableCurrencies = availableCurrencies.filter(function (x) {
          return _this3.user.factoringProvider.currencies.includes(x);
        });
      }
      return listCurrencies.filter(function (x) {
        return availableCurrencies.includes(x.id);
      });
    },
    canChangeSalesmanFollower: function canChangeSalesmanFollower() {
      var _this$user$salesman_f, _this$user$salesman_f2;
      return this.canManage && !((!!this.user.id_user || this.readOnly) && isSalesman(this.loggedUserData) && ((_this$user$salesman_f = this.user.salesman_follower) === null || _this$user$salesman_f === void 0 ? void 0 : _this$user$salesman_f.id_user) > 0 && ((_this$user$salesman_f2 = this.user.salesman_follower) === null || _this$user$salesman_f2 === void 0 ? void 0 : _this$user$salesman_f2.id_user) != this.loggedUserData.idUser);
    },
    paymentTerms: function paymentTerms() {
      if (isAdminNotConsultant(this.loggedUserData)) {
        return listTerms;
      } else {
        return this.listTermsCustomer;
      }
    },
    getFactoryProviders: function getFactoryProviders() {
      var _this4 = this;
      var list = [{
        id: null,
        name: "None"
      }];
      if (!this.canManageFactoringProviders) {
        var _this$user$factoring_3;
        if ((_this$user$factoring_3 = this.user.factoring_provider) !== null && _this$user$factoring_3 !== void 0 && _this$user$factoring_3.id) {
          list.push(this.user.factoring_provider);
        }
      } else {
        if (this.user.user_group == "USER") {
          list = [].concat(_toConsumableArray(list), _toConsumableArray(this.listFactoringProviders.filter(function (x) {
            return x.isIndividual && x.currencies.includes(_this4.user.default_currency);
          })));
        } else if (this.user.user_group == "WHOLESALER") {
          list = [].concat(_toConsumableArray(list), _toConsumableArray(this.listFactoringProviders.filter(function (x) {
            return x.isWholesaler && x.currencies.includes(_this4.user.default_currency);
          })));
        } else if (this.user.user_group == "HORECA" || this.user.user_group == "ADMIN" && this.user.user_sub_group == "CONSULTANT_HOLDING") {
          list = [].concat(_toConsumableArray(list), _toConsumableArray(this.listFactoringProviders.filter(function (x) {
            return x.isProfessional && x.currencies.includes(_this4.user.default_currency);
          })));
        }
      }
      return list;
    },
    listCountriesForDeliveryAddress: function listCountriesForDeliveryAddress() {
      var _this$user$factoring_4,
        _this5 = this;
      var copyCountries = _toConsumableArray(this.listCountries);
      var limitedLocations = getLimitedLocations(this.loggedUserData);
      if ((limitedLocations === null || limitedLocations === void 0 ? void 0 : limitedLocations.length) > 0) {
        var _this$user4;
        var countryIds = limitedLocations.map(function (x) {
          return x.country_id;
        });
        var deliveryCountryId = (_this$user4 = this.user) === null || _this$user4 === void 0 || (_this$user4 = _this$user4.delivery_address) === null || _this$user4 === void 0 || (_this$user4 = _this$user4.country) === null || _this$user4 === void 0 ? void 0 : _this$user4.id_country;
        if (deliveryCountryId > 0 && !countryIds.includes(deliveryCountryId)) {
          countryIds.push(deliveryCountryId);
        }
        copyCountries = copyCountries.filter(function (x) {
          return countryIds.includes(x.id_country);
        });
      }
      if (!this.canManageFactoringProviders && (_this$user$factoring_4 = this.user.factoring_provider) !== null && _this$user$factoring_4 !== void 0 && _this$user$factoring_4.id) {
        return copyCountries.filter(function (x) {
          return _this5.user.factoring_provider.currencies.includes(x.currency) || _this5.user.factoring_provider.currencies.includes("EUR") && x.currency != "USD";
        });
      }
      return copyCountries;
    },
    rangeAccess: function rangeAccess() {
      return listWineRangeAccessibility.filter(function (x) {
        return x.id !== 1;
      });
    },
    liquorNumberLabel: function liquorNumberLabel() {
      var _Object$values$find$l,
        _Object$values$find,
        _this6 = this;
      return (_Object$values$find$l = (_Object$values$find = Object.values(COUNTRY_SPECIAL_WORDINGS).find(function (x) {
        var _this6$user;
        return x.countryId == ((_this6$user = _this6.user) === null || _this6$user === void 0 || (_this6$user = _this6$user.delivery_address) === null || _this6$user === void 0 || (_this6$user = _this6$user.country) === null || _this6$user === void 0 ? void 0 : _this6$user.id_country);
      })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.liquorNumberLabel) !== null && _Object$values$find$l !== void 0 ? _Object$values$find$l : "Liquor certificate number";
    },
    taxIdLabel: function taxIdLabel() {
      var _Object$values$find$t,
        _Object$values$find2,
        _this7 = this;
      return (_Object$values$find$t = (_Object$values$find2 = Object.values(COUNTRY_SPECIAL_WORDINGS).find(function (x) {
        var _this7$user;
        return x.countryId == ((_this7$user = _this7.user) === null || _this7$user === void 0 || (_this7$user = _this7$user.delivery_address) === null || _this7$user === void 0 || (_this7$user = _this7$user.country) === null || _this7$user === void 0 ? void 0 : _this7$user.id_country);
      })) === null || _Object$values$find2 === void 0 ? void 0 : _Object$values$find2.taxIdLabel) !== null && _Object$values$find$t !== void 0 ? _Object$values$find$t : "VAT/Tax number";
    },
    individualCodeLabel: function individualCodeLabel() {
      var _Object$values$find$i,
        _Object$values$find3,
        _this8 = this;
      return (_Object$values$find$i = (_Object$values$find3 = Object.values(COUNTRY_SPECIAL_WORDINGS).find(function (x) {
        var _this8$user;
        return x.countryId == ((_this8$user = _this8.user) === null || _this8$user === void 0 || (_this8$user = _this8$user.delivery_address) === null || _this8$user === void 0 || (_this8$user = _this8$user.country) === null || _this8$user === void 0 ? void 0 : _this8$user.id_country);
      })) === null || _Object$values$find3 === void 0 ? void 0 : _Object$values$find3.individualCodeLabel) !== null && _Object$values$find$i !== void 0 ? _Object$values$find$i : "Legal code";
    }
  },
  created: function created() {
    var _this9 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this$$route$query, _this$$route$query$fr, _this$$route$query2, _this$user5;
      var _this, currentTerms, userHolding;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this9.$EventBus.$emit("loading", true);
            document.body.style.cursor = "wait";
            _this9.clientAppData = getClientAppData(_this9);
            _this = _this9;
            _this.user.id_user = (_this$$route$query = _this.$route.query) === null || _this$$route$query === void 0 ? void 0 : _this$$route$query.id_user;
            _this.isFromList = (_this$$route$query$fr = (_this$$route$query2 = _this.$route.query) === null || _this$$route$query2 === void 0 ? void 0 : _this$$route$query2.fromList) !== null && _this$$route$query$fr !== void 0 ? _this$$route$query$fr : false;
            _this.isAuthorized = !(!((_this$user5 = _this.user) !== null && _this$user5 !== void 0 && _this$user5.id_user) && !_this.canManage && !_this.canManageMyUsers);
            _context.next = 9;
            return _this9.fetchFactoringProviders();
          case 9:
            if (_this9.canGetCommissions()) {
              request("/v1/commissions/family_friends", "GET", null, true, "api").then(function (response) {
                _this.familyFriendsCommission = response.data.value;
              });
            }
            if (!isAdminNotConsultant(_this9.loggedUserData)) {
              _context.next = 13;
              break;
            }
            _context.next = 13;
            return _this9.getConsultantsList();
          case 13:
            //Get salespersons
            request("/v1/users", "post", {
              user_group: ["ADMIN"],
              roles: [process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER],
              active: true,
              isSalesman: true
            }, true, "api").then(function (response) {
              _this.listSalesman = response.data.users;
              _this.listSalesman.unshift({
                id_user: 0,
                fullname: "No salesperson attached"
              });
            });

            //Get countries
            request("/v1/countries?implantedMarket=true", "post", _this.clientAppData, false, "api").then(function (response) {
              _this.listCountries = _toConsumableArray(response.data.countries);
              _this.listStates = _toConsumableArray(response.data.states);
              document.body.style.cursor = "default";
              _this.$EventBus.$emit("loading", false);
            }).catch(function (_) {
              _this.$toasted.show("An error occured. Please contact an administrator.", {
                type: "error"
              });
              document.body.style.cursor = "default";
              _this.$EventBus.$emit("loading", false);
            });
            if (!_this.user.id_user) {
              _context.next = 21;
              break;
            }
            _context.next = 18;
            return _this.getUser();
          case 18:
            if (!isAdminNotConsultant(_this.loggedUserData)) {
              currentTerms = listTerms.find(function (x) {
                return x.id === _this9.user.id_term;
              });
              if (currentTerms && !listTermsCustomer.some(function (x) {
                return x.id === currentTerms.id;
              })) {
                _this9.listTermsCustomer = [].concat(_toConsumableArray(_this9.listTermsCustomer), [currentTerms]);
              }
            }
            _context.next = 28;
            break;
          case 21:
            if (isSalesman(_this.loggedUserData)) {
              _this.user.user_group = "HORECA";
              _this.user.salesman_follower.id_user = +_this.loggedUserData.idUser;
            }
            if (!isConsultantOrHolding(_this.loggedUserData)) {
              _context.next = 28;
              break;
            }
            _this.user.user_group = "HORECA";
            _context.next = 26;
            return getUserLogged();
          case 26:
            userHolding = _context.sent;
            _this.user.sponsorship_code = userHolding.consultant_code;
          case 28:
            _this.isLoaded = true;
          case 29:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    hasAccessToUserRoles: function hasAccessToUserRoles() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_USER_ROLES);
    },
    canGetCommissions: function canGetCommissions() {
      return hasRole(process.env.VUE_APP_ROLES_GET_COMMISSION);
    },
    goToUserRoles: function goToUserRoles() {
      return {
        name: "adminUserRoles",
        params: {
          fullname: getFullNameUser(this.user)
        },
        query: {
          id_user: this.user.id_user
        }
      };
    },
    goToUserOrders: function goToUserOrders() {
      return {
        name: "adminOrderList",
        query: {
          tab: "orders",
          id_user: this.user.id_user
        }
      };
    },
    goToConsultantOrders: function goToConsultantOrders() {
      return {
        name: "adminOrderList",
        query: {
          tab: "orders",
          consultantId: this.user.id_user
        }
      };
    },
    sendUserData: function sendUserData() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var isCreation, _orderHandler$getThir, confirmed, currentOrder, isChangingThirdPartySelected, isChangingCurrencyThirdPartySelected, isChangingCountryOfCurrentThirdParty, isChangingCountryWithCart, _this, dataBasket, data, responseSaveUser, _yield$orderHandler$f, dataNewBasket;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isCreation = !_this10.user.id_user;
              _this10.verifyFactoringProvider();
              if (!_this10.validateInputs()) {
                _context2.next = 38;
                break;
              }
              confirmed = true;
              currentOrder = orderHandler.getCurrentOrder();
              isChangingThirdPartySelected = !isCreation && _this10.user.id_user == ((_orderHandler$getThir = orderHandler.getThirdPartyUserSelected()) === null || _orderHandler$getThir === void 0 ? void 0 : _orderHandler$getThir.id_user);
              isChangingCurrencyThirdPartySelected = isChangingThirdPartySelected && _this10.initialCurrency !== _this10.user.default_currency;
              isChangingCountryOfCurrentThirdParty = isChangingThirdPartySelected && _this10.isChangingDeliveryCountry;
              isChangingCountryWithCart = isChangingCountryOfCurrentThirdParty && currentOrder && _this10.user.id_user == (currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id_user) && (currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.status) == orderStatus.find(function (x) {
                return x.id == "CREATED";
              }).status;
              if (!isChangingCountryWithCart) {
                _context2.next = 13;
                break;
              }
              _context2.next = 12;
              return _this10.$refs.confirm.open("CHANGE COUNTRY", "Are you sure you want to change the country of user ? All items in the cart will be removed !");
            case 12:
              confirmed = _context2.sent;
            case 13:
              if (!confirmed) {
                _context2.next = 38;
                break;
              }
              _this10.$EventBus.$emit("loading", true);
              _this = _this10;
              if (!isChangingCountryWithCart) {
                _context2.next = 22;
                break;
              }
              dataBasket = {
                orderId: +currentOrder.id_order,
                userId: +_this10.loggedUserData.idUser
              };
              _context2.next = 20;
              return request("/v1/basket/".concat(currentOrder.id_order), "delete", dataBasket, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                _this.$EventBus.$emit("loading", false);
                throw e;
              });
            case 20:
              orderHandler.removeOrderFromStorage();
              _this10.$EventBus.$emit("BasketRemoved");
            case 22:
              data = _objectSpread(_objectSpread({}, _this10.user), {}, {
                isHolding: _this10.user.user_sub_group == "CONSULTANT_HOLDING" ? true : false,
                pass: _this.user.password,
                delivery_address: _this.user.delivery_address,
                billing_address: _this.user.billing_is_delivery ? _objectSpread({}, _this.user.delivery_address) : _this.user.billing_address,
                salesman_follower: {
                  id_user: _this10.user.salesman_follower.id_user
                }
              });
              if (data.user_group == "USER") {
                data.company_name = "";
                data.vat_code = "";
                data.excise_code = "";
              } else {
                data.individualCode = "";
              }
              _context2.next = 26;
              return request("/v1/user" + (isCreation ? "" : "/" + _this.user.id_user), isCreation ? "post" : "put", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save user", true);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                _this.$EventBus.$emit("loading", false);
                throw e;
              });
            case 26:
              responseSaveUser = _context2.sent;
              _this10.$toasted.show("User saved.", {
                type: "success"
              });
              if (isChangingCurrencyThirdPartySelected) {
                setCurrencyUsedForCartAndExplore(_this10.user.default_currency);
                _this10.$EventBus.$emit("CurrencyUpdated", _this10.user.default_currency);
              }
              if (!(isChangingCountryOfCurrentThirdParty || isChangingCountryWithCart)) {
                _context2.next = 35;
                break;
              }
              _context2.next = 32;
              return orderHandler.fetchBasket();
            case 32:
              _yield$orderHandler$f = _context2.sent;
              dataNewBasket = _yield$orderHandler$f.dataNewBasket;
              if (!!dataNewBasket) {
                orderHandler.setCurrentOrder(dataNewBasket);
                _this10.$EventBus.$emit("update-cart");
              }
            case 35:
              if (isCreation) {
                _this10.user.id_user = responseSaveUser.data;
              }
              _this10.$EventBus.$emit("loading", false);
              _this10.getUser();
            case 38:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getIsUserAttachedToConsultant: function getIsUserAttachedToConsultant() {
      var _this = this;
      if (this.isUserHasSponsorshipCode) {
        request("/v1/consultant/".concat(_this.user.sponsorship_code), "get", null, true, "api").then(function (res) {
          _this.isUserAssociatedToConsultant = true;
          var consultant = _objectSpread({}, res.data);
          _this.user.delivery_address.country = consultant.delivery_address.country;
          _this.user.billing_address.country = consultant.delivery_address.country;
        }).catch(function (e) {
          var _e$response;
          if (((_e$response = e.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 || (_e$response = _e$response.value) === null || _e$response === void 0 ? void 0 : _e$response.errorCode) == "user_not_found") {
            //That means the user sponsorCode is a simple manual keypass
            _this.isUserAssociatedToConsultant = false;
          } else {
            throw e;
          }
        });
      } else {
        _this.isUserAssociatedToConsultant = false;
      }
    },
    getUser: function getUser() {
      var _this = this;
      if (!!_this.user.id_user) {
        _this.$EventBus.$emit("loading", true);
        return request("/v1/user/" + _this.user.id_user, "get", null, true, "api").then(/*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(response) {
            var _this$user$consultant, _this$user$sponsorshi2;
            var userLogged;
            return _regeneratorRuntime().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  _this.user = _objectSpread({}, response.data);
                  _this.initialDeliveryCountryId = _this.user.delivery_address.country.id_country;
                  _this.initialCurrency = _this.user.default_currency;
                  _this.user.billing_is_delivery = _this.compareAddresses();
                  _this.hide_billing_address = _this.user.billing_is_delivery;
                  _this.isUserConsultant = _this.user.user_group === "ADMIN" && ((_this$user$consultant = _this.user.consultant_code) === null || _this$user$consultant === void 0 ? void 0 : _this$user$consultant.length) > 0;
                  _this.isSalesman = _this.user.user_group === "ADMIN" && _this.user.isSalesman;
                  if (_this.user.user_group == "ADMIN") {
                    if (_this.isUserConsultant) _this.user.user_sub_group = _this.user.isHolding ? "CONSULTANT_HOLDING" : "CONSULTANT";else if (_this.isSalesman) _this.user.user_sub_group = "SALESMAN";else _this.user.user_sub_group = "ADMIN";
                  }
                  _this.isUserAssociatedToConsultant = isBuyerGroup(_this.user.user_group) && ((_this$user$sponsorshi2 = _this.user.sponsorship_code) === null || _this$user$sponsorshi2 === void 0 ? void 0 : _this$user$sponsorshi2.length) > 0;
                  if (_this.isUserAssociatedToConsultant) {
                    request("/v1/consultant/".concat(_this.user.sponsorship_code), "get", null, true, "api").then(function (response) {
                      _this.isUserAssociatedToConsultant = true;
                      if (_this.firstConnection) {
                        _this.user.delivery_address.country = response.data.delivery_address.country;
                        _this.user.billing_address.country = response.data.delivery_address.country;
                      }
                    }).catch(function (e) {
                      var _e$response2;
                      if (((_e$response2 = e.response) === null || _e$response2 === void 0 || (_e$response2 = _e$response2.data) === null || _e$response2 === void 0 || (_e$response2 = _e$response2.value) === null || _e$response2 === void 0 ? void 0 : _e$response2.errorCode) == "user_not_found") {
                        //That means the user sponsorCode is a simple manual keypass
                        _this.isUserAssociatedToConsultant = false;
                      } else {
                        throw e;
                      }
                    });
                  }
                  if (_this.user.salesman_follower == null) {
                    _this.user.salesman_follower = {
                      id_user: 0
                    };
                  }
                  if (!isConsultantOrHolding(_this.loggedUserData)) {
                    _context3.next = 16;
                    break;
                  }
                  _context3.next = 14;
                  return getUserLogged();
                case 14:
                  userLogged = _context3.sent;
                  if (userLogged.consultant_code != _this.user.sponsorship_code && (!_this.user.consultantAttached || _this.user.consultantAttached.sponsorship_code != userLogged.consultant_code)) {
                    _this.isAuthorized = false;
                  }
                case 16:
                  _this.selectConsultantOfUser();
                  _this.$EventBus.$emit("loading", false);
                case 18:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).catch(function (_) {
          _this.$toasted.show("An error occured. Please contact an administrator.", {
            type: "error"
          });
          _this.$EventBus.$emit("loading", false);
        });
      } else {
        this.$EventBus.$emit("loading", false);
      }
    },
    activateUser: function activateUser(withNotif) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this11$handlingUserA;
        var confirmed, _this, data;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this11.$refs.confirm.open("Activate", "Are you sure you want to <span class=\"bold\">activate</span> this user, ".concat(withNotif ? "WITH email notification" : "WITHOUT email notification", " ").concat(withNotif ? "<br><br> <p style='color: green'>This will notify the user <span class='text-bold'>WITH</span> an email notification.</p>" : "<br><br> <p style='color: red'>This <span class='text-bold'>WILL NOT</span> notify the user by email.</p>"), {
                isHtmlMessage: true,
                width: 400
              });
            case 2:
              confirmed = _context5.sent;
              if (confirmed) {
                _context5.next = 5;
                break;
              }
              return _context5.abrupt("return");
            case 5:
              _this11.handlingUserActivationStatus.activating.isPending = true;
              (_this11$handlingUserA = _this11.handlingUserActivationStatus.activating.cancellationToken) === null || _this11$handlingUserA === void 0 || _this11$handlingUserA.cancel();
              _this11.handlingUserActivationStatus.activating.cancellationToken = axios.CancelToken.source();
              _this = _this11;
              data = {
                IdUser: _this11.user.id_user,
                Active: true,
                WithNotification: withNotif
              };
              _context5.next = 12;
              return request("/v1/user/active", "put", data, true, "api", null, _this.handlingUserActivationStatus.activating.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.handlingUserActivationStatus.activating.isPending = false;
                          _this.handlingUserActivationStatus.activating.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to activate user.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 12:
              _this11.user.active = true;
              _this11.handlingUserActivationStatus.activating.isPending = false;
              _this11.handlingUserActivationStatus.activating.cancellationToken = null;
              _this11.$toasted.show("User activated.", {
                type: "success"
              });
            case 16:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    deactivateUser: function deactivateUser(withNotif) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this12$handlingUserA;
        var confirmed, _this, data;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this12.$refs.confirm.open("Deactivate user", "Are you sure you want to deactivate this user, ".concat(withNotif ? "WITH email notification" : "WITHOUT email notification", "  ").concat(withNotif ? "<br><br> <p style='color: green'>This will alert the user <span class='text-bold'>WITH</span> an email notification.</p>" : "<br><br> <p style='color: red'>This <span class='text-bold'>WILL NOT</span> notify the user by email.</p>"), {
                isHtmlMessage: true,
                width: 400
              });
            case 2:
              confirmed = _context7.sent;
              if (confirmed) {
                _context7.next = 5;
                break;
              }
              return _context7.abrupt("return");
            case 5:
              _this12.handlingUserActivationStatus.deactivating.isPending = true;
              (_this12$handlingUserA = _this12.handlingUserActivationStatus.deactivating.cancellationToken) === null || _this12$handlingUserA === void 0 || _this12$handlingUserA.cancel();
              _this12.handlingUserActivationStatus.deactivating.cancellationToken = axios.CancelToken.source();
              _this = _this12;
              data = {
                IdUser: _this12.user.id_user,
                Active: false,
                WithNotification: withNotif
              };
              _context7.next = 12;
              return request("/v1/user/active", "put", data, true, "api", null, _this.handlingUserActivationStatus.deactivating.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.handlingUserActivationStatus.deactivating.isPending = false;
                          _this.handlingUserActivationStatus.deactivating.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to activate user.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 12:
              _this12.user.active = false;
              _this12.handlingUserActivationStatus.deactivating.isPending = false;
              _this12.handlingUserActivationStatus.deactivating.cancellationToken = null;
              _this12.$toasted.show("User deactivated.", {
                type: "success"
              });
            case 16:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    acceptUserSubscription: function acceptUserSubscription(withNotif) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this13$handlingUserS;
        var confirmed, _this, data;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this13.$refs.confirm.open("Accept user subscription", "Are you sure you want to accept this user's subscription, ".concat(withNotif ? "WITH email notification" : "WITHOUT email notification", "  ").concat(withNotif ? "<br><br> <p style='color: green'>This will notify the user <span class='text-bold'>WITH</span> an email notification.</p>" : "<br><br> <p style='color: red'>This <span class='text-bold'>WILL NOT</span> notify the user by email.</p>"), {
                isHtmlMessage: true,
                width: 400
              });
            case 2:
              confirmed = _context9.sent;
              if (confirmed) {
                _context9.next = 5;
                break;
              }
              return _context9.abrupt("return");
            case 5:
              _this13.handlingUserSubscriptionStatus.accepting.isPending = true;
              (_this13$handlingUserS = _this13.handlingUserSubscriptionStatus.accepting.cancellationToken) === null || _this13$handlingUserS === void 0 || _this13$handlingUserS.cancel();
              _this13.handlingUserSubscriptionStatus.accepting.cancellationToken = axios.CancelToken.source();
              _this = _this13;
              data = {
                IdUser: _this13.user.id_user,
                Status: userSubscriptionStatus.ACCEPTED.id,
                WithNotification: withNotif
              };
              _context9.next = 12;
              return request("/v1/subscribe/status", "put", data, true, "api", null, _this.handlingUserSubscriptionStatus.accepting.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.handlingUserSubscriptionStatus.accepting.isPending = false;
                          _this.c.accepting.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to approve user subscription.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x4) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 12:
              _this13.user.active = true;
              _this13.user.subscriptionStatus = userSubscriptionStatus.ACCEPTED.id;
              _this13.user.isSubscriptionPendingActivation = false;
              _this13.handlingUserSubscriptionStatus.accepting.isPending = false;
              _this13.handlingUserSubscriptionStatus.accepting.cancellationToken = null;
              _this13.$toasted.show("User subscription accept.", {
                type: "success"
              });
            case 18:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    declineUserSubscription: function declineUserSubscription(withNotif) {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this14$handlingUserS;
        var confirmed, _this, data;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this14.$refs.confirm.open("Decline user subscription", "Are you sure you want to decline this user's subscription, ".concat(withNotif ? "WITH email notification" : "WITHOUT email notification", "  ").concat(withNotif ? "<br><br> <p style='color: green'>This will alert the user <span class='text-bold'>WITH</span> an email notification.</p>" : "<br><br> <p style='color: red'>This <span class='text-bold'>WILL NOT</span> notify the user by email.</p>"), {
                isHtmlMessage: true,
                width: 400
              });
            case 2:
              confirmed = _context11.sent;
              if (confirmed) {
                _context11.next = 5;
                break;
              }
              return _context11.abrupt("return");
            case 5:
              _this14.handlingUserSubscriptionStatus.declining.isPending = true;
              (_this14$handlingUserS = _this14.handlingUserSubscriptionStatus.declining.cancellationToken) === null || _this14$handlingUserS === void 0 || _this14$handlingUserS.cancel();
              _this14.handlingUserSubscriptionStatus.declining.cancellationToken = axios.CancelToken.source();
              _this = _this14;
              data = {
                IdUser: _this14.user.id_user,
                Status: userSubscriptionStatus.DECLINED.id,
                WithNotification: withNotif
              };
              _context11.next = 12;
              return request("/v1/subscribe/status", "put", data, true, "api", null, _this.handlingUserSubscriptionStatus.declining.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.handlingUserSubscriptionStatus.declining.isPending = false;
                          _this.handlingUserSubscriptionStatus.declining.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to decline user subscription.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee10);
                }));
                return function (_x5) {
                  return _ref5.apply(this, arguments);
                };
              }());
            case 12:
              _this14.user.active = false;
              _this14.user.subscriptionStatus = userSubscriptionStatus.DECLINED.id;
              _this14.user.isSubscriptionPendingActivation = false;
              _this14.handlingUserSubscriptionStatus.declining.isPending = false;
              _this14.handlingUserSubscriptionStatus.declining.cancellationToken = null;
              _this14.$toasted.show("User subscription declined.", {
                type: "success"
              });
            case 18:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    resetSubscriptionStatus: function resetSubscriptionStatus() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this15$handlingUserS;
        var confirmed, _this, data;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return _this15.$refs.confirm.open("Return to pending status", "Are you sure to reset this user's subscription status ? You will be able to activate the user, for example.", {
                isHtmlMessage: true,
                width: 400
              });
            case 2:
              confirmed = _context13.sent;
              if (confirmed) {
                _context13.next = 5;
                break;
              }
              return _context13.abrupt("return");
            case 5:
              _this15.handlingUserSubscriptionStatus.resetting.isPending = true;
              (_this15$handlingUserS = _this15.handlingUserSubscriptionStatus.resetting.cancellationToken) === null || _this15$handlingUserS === void 0 || _this15$handlingUserS.cancel();
              _this15.handlingUserSubscriptionStatus.resetting.cancellationToken = axios.CancelToken.source();
              _this = _this15;
              data = {
                IdUser: _this15.user.id_user
              };
              _context13.next = 12;
              return request("/v1/subscribe/status/reset", "put", data, true, "api", null, _this.handlingUserSubscriptionStatus.resetting.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                    while (1) switch (_context12.prev = _context12.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.handlingUserSubscriptionStatus.resetting.isPending = false;
                          _this.handlingUserSubscriptionStatus.resetting.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to reset user subscription.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context12.stop();
                    }
                  }, _callee12);
                }));
                return function (_x6) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 12:
              _this15.user.subscriptionStatus = userSubscriptionStatus.PENDING.id;
              _this15.user.isSubscriptionPendingActivation = true;
              _this15.handlingUserSubscriptionStatus.resetting.isPending = false;
              _this15.handlingUserSubscriptionStatus.resetting.cancellationToken = null;
              _this15.$toasted.show("User subscription reset.", {
                type: "success"
              });
            case 17:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    resendWelcomeMail: function resendWelcomeMail() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this16$welcomeMailCa;
        var _this;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this16.$EventBus.$emit("loading", true);
              (_this16$welcomeMailCa = _this16.welcomeMailCancellationToken) === null || _this16$welcomeMailCa === void 0 || _this16$welcomeMailCa.cancel();
              _this16.welcomeMailCancellationToken = axios.CancelToken.source();
              _this = _this16;
              _context14.next = 6;
              return request("/v1/user/".concat(_this.user.id_user, "/welcome-mail"), "post", {}, true, "api", null, _this.welcomeMailCancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                _this.$EventBus.$emit("loading", false);
                throw e;
              });
            case 6:
              _this16.$toasted.show("Welcome mail resent.", {
                type: "success"
              });
              _this16.$EventBus.$emit("loading", false);
            case 8:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    compareAddresses: function compareAddresses() {
      var delivery = _objectSpread({}, this.user.delivery_address);
      delete delivery.id_address;
      delete delivery.deliveryInstructions;
      var billing = _objectSpread({}, this.user.billing_address);
      delete billing.id_address;
      delete billing.deliveryInstructions;
      return JSON.stringify(delivery) == JSON.stringify(billing);
    },
    validateInputs: function validateInputs() {
      this.errorLabels = cleanErrors(this.errorLabels);
      if (this.user.login == "") {
        this.errorLabels.login = this.errorMessages.mandatory;
      } else if (!regExpMail.test(this.user.login)) {
        this.errorLabels.login = this.errorMessages.email.format;
      }
      if (this.user.name == "") {
        this.errorLabels.name = this.errorMessages.mandatory;
      }
      if (this.user.nickname == "") {
        this.errorLabels.nickname = this.errorMessages.mandatory;
      }
      if (this.user.phone == "") {
        this.errorLabels.phone = this.errorMessages.mandatory;
      } else if (!regExpPhone.test(this.user.phone)) {
        this.errorLabels.phone = this.errorMessages.phone.format;
      }
      if (!this.user.company_name && (this.user.user_group == "HORECA" || this.user.user_group == "WHOLESALER" || this.user.isHolding)) {
        this.errorLabels.company_name = this.errorMessages.mandatory;
      }
      if (!String.isNullOrEmpty(this.user.billingEmail) && !regExpMail.test(this.user.billingEmail)) {
        this.errorLabels.billingEmail = this.errorMessages.email.format;
      }
      if (!String.isNullOrEmpty(this.user.contactEmail) && !regExpMail.test(this.user.contactEmail)) {
        this.errorLabels.contactEmail = this.errorMessages.email.format;
      }
      if (!this.user.user_group) {
        this.errorLabels.user_group = this.errorMessages.mandatory;
      }
      if (!this.user.vat_code && (this.user.user_group == "HORECA" || this.user.user_group == "WHOLESALER")) {
        this.errorLabels.vat_code = this.errorMessages.mandatory;
      }
      if (this.isUserConsultantOrHolding && !regexpConsulantCode.test(this.user.consultant_code)) {
        this.errorLabels.consultant_code = this.errorMessages.consultant_code.format;
      }
      if (this.user.id_language == "") {
        this.errorLabels.id_language = this.errorMessages.mandatory;
      }
      if (this.user.user_group == "") {
        this.errorLabels.user_group = this.errorMessages.mandatory;
      }
      if (this.user.id_term == "") {
        this.errorLabels.id_term = this.errorMessages.mandatory;
      }
      if (!this.$refs.addressDelivery.validateForm()) {
        return false;
      }
      if (!this.user.billing_is_delivery) {
        if (!this.$refs.addressBilling.validateForm()) {
          return false;
        }
      }
      return noErrors(this.errorLabels);
    },
    changeUserGroup: function changeUserGroup() {
      if (!isBuyerGroup(this.user.user_group)) {
        this.user.has_bypass_buy_limit = false;
        this.user.is_allowed_order_without_payment = false;
        this.user.salesman_follower = {
          id_user: 0
        };
      } else {
        if (isSalesman(this.loggedUserData)) {
          this.user.salesman_follower.id_user = +this.loggedUserData.idUser;
        }
      }
      this.verifyFactoringProvider();
    },
    openSendMailModal: function openSendMailModal() {
      var _this17 = this;
      this.sendMailModalShown = true;
      this.$nextTick(function () {
        _this17.$refs.SendMailModal.open();
      });
    },
    closeSendMailModal: function closeSendMailModal() {
      var _this18 = this;
      this.$nextTick(function () {
        _this18.sendMailModalShown = false;
      });
    },
    generateConsultanteCode: function generateConsultanteCode() {
      var generatedCode = "C_M_".concat(this.user.name.charAt(0) + this.user.nickname.substring(0, 3));
      this.user.consultant_code = generatedCode.toUpperCase();
    },
    getConsultantsList: function getConsultantsList() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var _this19$gettingConsul;
        var _this, data, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this19.gettingConsultants.isPending = true;
              (_this19$gettingConsul = _this19.gettingConsultants.cancellationToken) === null || _this19$gettingConsul === void 0 || _this19$gettingConsul.cancel();
              _this19.gettingConsultants.cancellationToken = axios.CancelToken.source();
              _this = _this19;
              data = {
                onlyActive: false,
                excludeAllowedToDispatchToAnyCustomer: true
              };
              paramsQuery = Object.encodeToUri(data);
              _context15.next = 8;
              return request("/v1/users/consultants?params=".concat(paramsQuery), "get", null, true, "api", null, _this.gettingConsultants.cancellationToken).catch(function (e) {
                _this.gettingConsultants.isPending = false;
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load the list of consultants.");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 8:
              response = _context15.sent;
              _this19.gettingConsultants.items = _toConsumableArray(response.data.value);
              _this19.gettingConsultants.items.forEach(function (x) {
                return x.displayName = x.fullname + " - " + x.consultant_code + (x.isHolding ? " - Corporate" : "") + (x.active === false ? " - Deactivated" : "");
              });
              _this19.gettingConsultants.items.sort(function (a, b) {
                if (a.active !== b.active) {
                  return a.active ? -1 : 1;
                }
                if (a.isHolding !== b.isHolding) {
                  return a.isHolding ? 1 : -1;
                }
                return a.fullname.localeCompare(b.fullname);
              });
              _this19.gettingConsultants.isPending = false;
            case 13:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    updateSponsorshipCode: function updateSponsorshipCode(value) {
      if (_typeof(value) === "object" && value !== null) {
        this.user.sponsorship_code = value.consultant_code;
      } else {
        this.user.sponsorship_code = value !== null && value !== void 0 ? value : "";
      }
    },
    copyConsultantCode: function copyConsultantCode() {
      this.user.sponsorship_code = this.user.consultant_code;
      this.selectConsultantOfUser();
    },
    selectConsultantOfUser: function selectConsultantOfUser() {
      var _this20 = this;
      if (isAdminNotConsultant(this.loggedUserData)) {
        var _this$user$sponsorshi3;
        if (((_this$user$sponsorshi3 = this.user.sponsorship_code) === null || _this$user$sponsorshi3 === void 0 ? void 0 : _this$user$sponsorshi3.length) > 0) {
          var _this$gettingConsulta;
          this.selectedConsultant = (_this$gettingConsulta = this.gettingConsultants.items) === null || _this$gettingConsulta === void 0 ? void 0 : _this$gettingConsulta.find(function (x) {
            return x.consultant_code === _this20.user.sponsorship_code;
          });
          if (!this.selectedConsultant) {
            this.selectedConsultant = this.user.sponsorship_code;
          }
        } else {
          this.selectedConsultant = null;
        }
      }
    },
    fetchFactoringProviders: function fetchFactoringProviders() {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (!_this21.canManageFactoringProviders) {
                _context16.next = 7;
                break;
              }
              _this = _this21;
              data = {
                withAvailabilities: true,
                includeDeleted: false
              };
              _context16.next = 5;
              return request("/v1/factoring-providers/all", "post", data, true, "api", null).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load financing options.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
                throw e;
              });
            case 5:
              response = _context16.sent;
              _this21.listFactoringProviders = response.data.value.items;
            case 7:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    verifyFactoringProvider: function verifyFactoringProvider() {
      var _this$user$factoring_5,
        _this22 = this;
      if (this.canManageFactoringProviders && ((_this$user$factoring_5 = this.user.factoring_provider) === null || _this$user$factoring_5 === void 0 ? void 0 : _this$user$factoring_5.id) != null) {
        if (!this.getFactoryProviders.some(function (x) {
          return x.id == _this22.user.factoring_provider.id;
        })) {
          this.user.factoring_provider.id = null;
        }
      }
    },
    startAddingLimitedLocation: function startAddingLimitedLocation() {
      this.addingLimitedLocation.form = {
        countryId: null,
        stateId: null
      };
      this.resetAddingLimitedLocationStates();
      this.addingLimitedLocation.isConfiguring = true;
    },
    resetAddingLimitedLocationStates: function resetAddingLimitedLocationStates() {
      var _this23 = this;
      this.addingLimitedLocation.form.stateId = null;
      this.addingLimitedLocation.availableStates = this.listStates.filter(function (x) {
        return x.id_country === _this23.addingLimitedLocation.form.countryId;
      });
    },
    addLimitedLocation: function addLimitedLocation() {
      var _this24 = this;
      if (this.addingLimitedLocation.form.countryId > 0) {
        var country = this.listCountries.find(function (x) {
          return x.id_country === _this24.addingLimitedLocation.form.countryId;
        });
        var state = this.listStates.find(function (x) {
          return x.id_state === _this24.addingLimitedLocation.form.stateId;
        });
        var newDto = {
          country: _objectSpread({}, country),
          state: _objectSpread({}, state)
        };
        this.user.limitedLocations.push(_objectSpread({}, newDto));
        this.addingLimitedLocation.isConfiguring = false;
      }
    },
    removeLimitedLocation: function removeLimitedLocation(location) {
      this.user.limitedLocations = this.user.limitedLocations.filter(function (x) {
        var _x$state, _location$state;
        return !(x.country.id_country === location.country.id_country && ((_x$state = x.state) === null || _x$state === void 0 ? void 0 : _x$state.id_state) === ((_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.id_state));
      });
    },
    isAdminNotConsultant: isAdminNotConsultant,
    isSuperAdmin: isSuperAdmin,
    isHolding: isHolding,
    isConsultantOrHolding: isConsultantOrHolding,
    isBuyerGroup: isBuyerGroup,
    filterVAutocomplete: filterVAutocomplete
  },
  watch: {
    isFamilyFriendsAvailable: function isFamilyFriendsAvailable(available) {
      if (!available) {
        this.user.isFamilyFriends = false;
      }
    },
    listDefaultCurrencies: function listDefaultCurrencies(currencies) {
      var _this$user6;
      if (currencies.length === 1) {
        this.user.default_currency = currencies[0].id;
      } else if (currencies.length > 0 && !currencies.map(function (x) {
        return x.id;
      }).includes((_this$user6 = this.user) === null || _this$user6 === void 0 ? void 0 : _this$user6.default_currency)) {
        this.user.default_currency = currencies[0].id;
      } else if (currencies.length === 0) {
        this.user.default_currency = null;
      }
      this.verifyFactoringProvider();
    }
  }
};